import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { classNames } from 'primereact/utils';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { CAMENU } from '../../constants';
import { useGetCaManagerTlSearchQuery } from '../../features/correctiveActions/managerTlViewSearch/CaMangerTLView.slice';
import {
    selectCurrentEmpid,
    selectImpEmpid,
    selectIsDelegate,
    // setCaTabSelection,
} from '../../pages/login/authSlice';
import { CaMenuTabindex, CaStatusNames } from '../../utils/typeConstants';
import networkToastService from '../networkStatus/networkToastService';
import './correctiveActionsToast.scss';

/* eslint-disable react/react-in-jsx-scope */
export const CorrectiveActionsToast = () => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const isDelegate = useSelector<boolean | undefined | null>(selectIsDelegate);
    const loggedImpEmpid = useSelector(selectImpEmpid);

    const primeToastAck   = useRef<Toast | null>(null);
    const refreshCountRef = useRef(0);

    const [primeToastAckMargin, setPrimeToastAckMargin] = useState<any>({});
    const primeToastAckShownRef = useRef(false);

    const navigate = useNavigate();

    useEffect(() => {
        networkToastService.onSharedToastsChange = () => {
            if (!primeToastAckShownRef.current) return;
            const count = networkToastService.sharedToastCount;
            setPrimeToastAckMargin(count > 0 ? { marginTop: `${count * 95}px` } : {});
        };
        return () => { networkToastService.onSharedToastsChange = null; };
    }, []);

    useEffect(() => {
        if (networkToastService.isCorrectiveShown) {
            networkToastService.correctiveOnClick = () =>
                navigate(CAMENU + '/' + CaMenuTabindex.NeedsAction, { replace: true });
        }
    });

    useEffect(() => {
        primeToastAck.current?.clear();
        networkToastService.hideCorrective();
    }, [loggedEmpNum, loggedImpEmpid]);

    const { data: caApproversDataSlice } = useGetCaManagerTlSearchQuery(
        { employeeNumber: loggedEmpNum, isCurrentTeam: undefined, isApprovals: true },
        { skip: !loggedEmpNum }
    );

    const { data: caAckDataSlice } = useGetCaManagerTlSearchQuery(
        {
            employeeNumber: loggedEmpNum,
            isApprovals: false,
        },
        {
            skip: !loggedEmpNum || isDelegate,
        }
    );

    useEffect(() => {
        if (loggedEmpNum && caApproversDataSlice?.data?.length > 0) {
            const needsActnData = caApproversDataSlice.data.filter((item: any) => item.expired === false);
            if (needsActnData.length > 0) {
                networkToastService.showCorrective(
                    ` You have ${needsActnData.length} Corrective Action(s) that requires attention`,
                    () => navigate(CAMENU + '/' + CaMenuTabindex.NeedsAction, { replace: true })
                );
            }
        }
    }, [caApproversDataSlice]);

    useEffect(() => {
        if (loggedEmpNum && caAckDataSlice?.data?.length > 0) {
            const ifAckData = caAckDataSlice.data.filter(
                (item: any) => item.ca_status_name === CaStatusNames.Release && item.expired === false
            );
            if (primeToastAck.current && ifAckData.length > 0 && refreshCountRef.current === 0) {
                showAcknowledgementToast(
                    `You have ${ifAckData.length} Corrective Action(s) to acknowledge`,
                    CAMENU,
                    CaMenuTabindex.MyCorrectiveActions
                );
            }
        }
    }, [caAckDataSlice]);
    const handleClose = (toastRef: React.MutableRefObject<any>) => {
        if (toastRef.current) {
            toastRef.current.clear();
            primeToastAckShownRef.current = false;
            setPrimeToastAckMargin({});
        }
    };
    const showAcknowledgementToast = (message: string, navLink: string, tabindex: number) => {
        primeToastAckShownRef.current = true;
        const sharedCount = networkToastService.sharedToastCount;
        setPrimeToastAckMargin(sharedCount > 0 ? { marginTop: `${sharedCount * 95}px` } : {});
        primeToastAck.current?.clear();
        setTimeout(() => {
            primeToastAck?.current?.show({
                detail: (
                    <div className="p-d-flex p-ai-center">
                        <p
                            style={{ display: 'flex', alignItems: 'center' }}
                            className={classNames('pi', 'pi-history', 'pi-mr-2')}
                        >
                            <p style={{ marginLeft: '5px' }}>{message}</p>
                            <Button
                                style={{ background: 'transparent', border: '0px' }}
                                type="button"
                                icon="pi pi-arrow-right"
                                onClick={() => {
                                    //primeToastAck.current?.clear();
                                    // dispatch(setCaTabSelection(tabindex));
                                    navigate(navLink + '/' + tabindex);
                                    handleClose(primeToastAck);
                                }}
                            />
                        </p>
                    </div>
                ),
                closable: true,
                sticky: true,
                className: 'custon-pink',
            });
        }, 1000);
    };

    return (
        <div>
            {loggedEmpNum?.length > 5 && (
                <Toast ref={primeToastAck} position="top-center" style={primeToastAckMargin} />
            )}
        </div>
    );
};
